import Header from '@/components/feature/Header';
import WhatsAppFloat from '@/components/feature/WhatsAppFloat';
import BackToTop from '@/components/feature/BackToTop';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SolutionCards from './components/SolutionCards';
import EnergySection from './components/EnergySection';
import InsuranceSection from './components/InsuranceSection';
import TelecomSection from './components/TelecomSection';
import LicenseSection from './components/LicenseSection';
import ClubSection from './components/ClubSection';
import TestimonialsSection from './components/TestimonialsSection';
import CompanySection from './components/CompanySection';
import RecognitionSection from './components/RecognitionSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <div className="relative">
      <Header />
      <main>
        <HeroSection />
        <SolutionCards />
        <EnergySection />
        <TestimonialsSection />
        <InsuranceSection />
        <TelecomSection />
        <LicenseSection />
        <ClubSection />
        <CompanySection />
        <RecognitionSection />
        <FAQSection />
      </main>
      <Footer />
      <BackToTop />
      <WhatsAppFloat />
    </div>
  );
}
